import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import './App.css';
import Home from './components/Home';
import Tool02 from './components/Tool02';
import Tool03 from './components/Tool03';
import Tool04 from './components/Tool04';
import Tool05 from './components/Tool05';
import Tool06 from './components/Tool06';
import Tool07 from './components/Tool07';
import Tool08 from './components/Tool08';
import Tool09 from './components/Tool09';

export default function App() {
  return (
    <Router>
      <Switch>

        <Route path="/tool09">
          <Tool09 />
        </Route>

        <Route path="/tool08">
          <Tool08 />
        </Route>

        <Route path="/tool07">
          <Tool07 />
        </Route>

        <Route path="/tool06">
          <Tool06 />
        </Route>

        <Route path="/tool05">
          <Tool05 />
        </Route>

        <Route path="/tool04">
          <Tool04 />
        </Route>

        <Route path="/tool03">
          <Tool03 />
        </Route>

        <Route path="/tool02">
          <Tool02 />
        </Route>

        <Route path="/">
          <Home />
        </Route>

      </Switch>
    </Router>
  )
};